import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { UserType } from '@buck-e-icp/interfaces';
import { Store } from '@ngrx/store';
import { filter, first, map } from 'rxjs';

import { selectActiveProfile } from '../../auth/store';
import { selectStateDone } from '../../shared/utils';
import { routingConfig } from '../services/default-route.service';

export const userTypeGuard =
    (allowedTypes: UserType[]): CanMatchFn =>
    () => {
        const store = inject(Store);
        const router = inject(Router);
        return store.select(selectActiveProfile).pipe(
            filter(selectStateDone),
            map((userProfile) =>
                allowedTypes.find((t) => t === userProfile.result?.type)
                    ? true
                    : router.createUrlTree([routingConfig.unauthorizedRedirect]),
            ),
            first(),
        );
    };
